import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { CertifiedCarBagde, LiteCarBagde, DealerCarBagde } from 'public/Images';
import Image, { StaticImageData } from 'next/image';
import { useTranslation } from 'react-i18next';

export const CarTypeDescription = ({ carType }: { carType: CarTypesEnum }) => {
    const { t } = useTranslation();
    const descriptionMap: Record<CarTypesEnum, JSX.Element> = {
        [CarTypesEnum.CERTIFIED]: (
            <TypeDesc
                image={CertifiedCarBagde}
                title={t('CarProfile.CarType.certifiedDescTitle')}
                subTitle={t('CarProfile.CarType.certifiedDescSubTitle')}
            />
        ),
        [CarTypesEnum.LITE]: (
            <TypeDesc
                image={LiteCarBagde}
                title={t('CarProfile.CarType.liteDescTitle')}
                subTitle={t('CarProfile.CarType.liteDescSubTitle')}
            />
        ),
        [CarTypesEnum.Dealer]: (
            <TypeDesc
                image={DealerCarBagde}
                title={t('CarProfile.CarType.dealerDescTitle')}
                subTitle={t('CarProfile.CarType.dealerDescSubTitle')}
            />
        ),
    };
    return <>{descriptionMap[carType]}</>;
};

const TypeDesc = ({
    image,
    title,
    subTitle,
}: {
    image: StaticImageData;
    title: string;
    subTitle: string;
}) => {
    return (
        <div className="flex flex-col items-center md:flex-row md:gap-x-3">
            <Image src={image} alt="car badge" />
            <div className="md:flex md:flex-col justify-center text-center md:text-start">
                <div className="text-gray-800 text-subtitle2SemiBold">
                    {title}
                </div>
                <div className="text-gray-600 text-caption md:text-body2">
                    {subTitle}
                </div>
            </div>
        </div>
    );
};
